export default {
  DISCORD: "https://discord.gg/acre",
  DOCS: "https://docs.acre.fi",
  FAQ: "https://docs.acre.fi/faq",
  CONTRACTS: "https://docs.acre.fi/contracts",
  BLOG: "https://blog.acre.fi",
  WEBSITE: "https://acre.fi",
  TERMS_OF_USE: "https://acre.fi/terms-of-use",
  PRIVACY_POLICY: "https://acre.fi/privacy-policy",
  X: "https://x.com/AcreBTC",
  RE7: "https://www.re7labs.xyz/",
  MIDAS: "https://midas.app/",
  MIDAS_TEAM: "https://midas.app/team",
  ACRE_DEPLOYMENT_POLICY: "https://docs.acre.fi/acre-deployment-policy",
  AAVE: "https://aave.com/",
  GIZA: "https://www.gizatech.xyz/",
  RE7_CAPITAL: "https://re7.capital/",
  WALLET_GUIDE: "https://docs.acre.fi/acre-dapp/sign-in",
  THRESHOLD_ACRE_VAULT: "https://app.threshold.network/vaults/acre",
}
